import { createSlice } from '@reduxjs/toolkit'

import { AGENCY_FILTER } from 'apps/agency/model/constants'
import type { AgencyAgenciesFilters } from 'shared/api/requests/agency/schemas'

import { fetchAgencyFilters } from './thunks'

interface AgencyListingState {
  filtersData: AgencyAgenciesFilters & {
    isFetching: boolean
    isFetched: boolean
  }
  filters: {
    [AGENCY_FILTER.name]: string
    [AGENCY_FILTER.country]: string | null
    [AGENCY_FILTER.industry]: string | null
  }
}

export const initialState: AgencyListingState = {
  filtersData: {
    countries: [],
    industries: {},
    isFetching: false,
    isFetched: false,
  },
  filters: {
    [AGENCY_FILTER.name]: '',
    [AGENCY_FILTER.country]: null,
    [AGENCY_FILTER.industry]: null,
  },
}

const listingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase('APP_UPDATE_CURRENT_ACCOUNT_ID', () => initialState)
      .addCase(fetchAgencyFilters.pending, (state) => {
        state.filtersData.isFetching = true
      })
      .addCase(fetchAgencyFilters.fulfilled, (state, action) => {
        state.filtersData.countries = action.payload.countries
        state.filtersData.industries = action.payload.industries
        state.filtersData.isFetching = false
        state.filtersData.isFetched = true
      })
      .addCase(fetchAgencyFilters.rejected, (state) => {
        state.filtersData.isFetching = false
      })
  },
})

export default listingSlice.reducer
